import { Typography, Stack, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { getScore } from '../services/Score';
import { convertMinsToHrsMins } from '../utils/Math';

const getPlaytimeFormatted = (playtime) => {
  const hoursAndMins = convertMinsToHrsMins(playtime);
  return `${Number(hoursAndMins.hours)} timer og ${Number(hoursAndMins.minutes)} minutter`;
};

const clubColumns = [
  {
    headerName: 'Klubb',
    field: 'club',
    flex: 4,
  },
  {
    headerName: 'Registert tid',
    field: 'playtime',
    flex: 4,
    renderCell: ({ row }) => <>{getPlaytimeFormatted(row.playtime)}</>,
  },
];

const teamColumns = [
  {
    headerName: 'Lag',
    field: 'team',
    flex: 1,
  },
  {
    headerName: 'Registert tid',
    field: 'playtime',
    flex: 1,
    renderCell: ({ row }) => <>{getPlaytimeFormatted(row.playtime)}</>,
  },
];

const Leaderboard = () => {
  const [score, setScore] = useState([]);

  useEffect(() => {
    getScore(new Date().getFullYear())
      .then((response) => setScore(response))
      .catch((err) => console.log(err));
  }, []);

  return (
    <div>
      <Stack spacing={2}>
        <Typography variant="body1">Her kan du se hvilken klubb og lag som ligger best an denne sesongen.</Typography>
        <Box pt={2}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Beste klubb 👑
          </Typography>
          <DataGrid
            columns={clubColumns}
            rows={score?.clubLeaderboard ?? []}
            getRowId={(row) => row.club}
            headerHeight={40}
            pageSize={5}
            rowsPerPageOptions={[5]}
            autoHeight
          />
        </Box>
        <Box pt={2}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Beste lag 🎖
          </Typography>
          <DataGrid
            columns={teamColumns}
            rows={score?.teamLeaderboard ?? []}
            getRowId={(row) => row.team}
            headerHeight={40}
            pageSize={5}
            rowsPerPageOptions={[5]}
            autoHeight
          />
        </Box>
      </Stack>
    </div>
  );
};

export default Leaderboard;
